import { AxiosPublic } from "../config/axios";

export async function getProducts(query) {
    return await AxiosPublic.get("painting_with_frame", { params: { ...query } })
        .then(res => res.data.data)
        .catch(err => { alert(err.response?.data.message); return null })
}
export async function getOneProduct(id, query) {
    return await AxiosPublic.get("painting_with_frame/show/" + id, { params: { ...query } })
        .then(res => res.data.data)
        .catch(err => { alert(err.response?.data.message); return null })
}
